import {
    CircularProgress,
    Stack,
    Typography
} from "@mui/material";
import SortableList from "../../_atoms/admin/SortableList";
import {useEffect, useRef, useState} from "react";
import DialogModal from "../../_atoms/admin/DialogModal";

const SortableListModal = (props) => {
    const items = useRef(props.items);
    const [isLoading, setIsLoading] = useState(props.isLoading);

    useEffect(() => {
        items.current = props.items;
        setIsLoading(props.isLoading);
    }, [props]);

    const onItemsSort = (sortedItems) => {
        items.current = sortedItems;
    }

    return <>
        <DialogModal
            onClose={props.onClose}
            open
            fullWidth
            maxWidth='lg'
            title={props.title}
            actions={[
                {
                    variant: 'contained',
                    onClick: props.onSubmit ? () => {props.onSubmit(items.current)} : props.onClose,
                    label: 'OK'
                }
            ]}
            >
            {props.subtitle && <Typography sx={{mb: 2}} variant='body1' color='grey'>
                {props.subtitle}
            </Typography>}
            {items.current.length > 0 && <SortableList items={items.current} onItemsSort={onItemsSort} />}
            {items.current.length === 0 && <Stack direction='column' gap={2} alignItems='center' justifyContent='center'>
                {!isLoading && <>
                        <Typography varian='body1'>{props.noDataText}</Typography>
                    </>
                }
                {isLoading && <>
                        <CircularProgress size={25} />
                        <Typography varian='body1'>{props.loadingText}</Typography>
                    </>
                }
            </Stack>}
        </DialogModal>
    </>
}

export default SortableListModal;